import { DocumentsTable } from "@/components/documents/documents-table";
import { createFileRoute } from "@tanstack/react-router";

function DocumentsPage() {
  return <DocumentsTable />;
}

export const Route = createFileRoute("/_authenticated/website/documents/")({
  component: DocumentsPage,
});
